import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminFAQ() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const refresh = () => api.get("/admin/faqs").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const save = async () => {
    try {
      if (edit.id) await api.put(`/admin/faqs/${edit.id}`, edit);
      else await api.post("/admin/faqs", edit);
      toast.success("Salvato"); setEdit(null); refresh();
    } catch (e) { toast.error("Errore"); }
  };
  const del = async (id) => { if (!window.confirm("Eliminare?")) return; try { await api.delete(`/admin/faqs/${id}`); refresh(); } catch (e) { toast.error("Errore"); } };
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-display text-2xl font-bold text-slate-900">FAQ</h1><p className="text-sm text-slate-600">Gestisci le domande frequenti visibili sul sito.</p></div>
        <Button onClick={() => setEdit({ question: "", answer: "", category: "Generale", order: 0, active: true })} className="bg-[#2D6BFF] text-white"><Plus size={14} className="mr-1" /> Nuova FAQ</Button>
      </div>
      <div className="space-y-3">
        {items.map(f => (
          <div key={f.id} className="cxo-card p-4">
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1">
                <p className="font-semibold text-slate-900">{f.question}</p>
                <p className="text-sm text-slate-600 mt-1">{f.answer}</p>
                <p className="text-xs text-slate-400 mt-1">{f.category}</p>
              </div>
              <div className="flex gap-1"><Button size="sm" variant="ghost" onClick={() => setEdit(f)}><Edit size={14} /></Button><Button size="sm" variant="ghost" onClick={() => del(f.id)}><Trash2 size={14} className="text-red-500" /></Button></div>
            </div>
          </div>
        ))}
      </div>
      {edit && (
        <Dialog open onOpenChange={(o) => !o && setEdit(null)}>
          <DialogContent>
            <DialogHeader><DialogTitle>{edit.id ? "Modifica" : "Nuova"} FAQ</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Categoria</Label><Input value={edit.category || ""} onChange={e => setEdit({...edit, category: e.target.value})} /></div>
              <div><Label>Domanda</Label><Input value={edit.question} onChange={e => setEdit({...edit, question: e.target.value})} /></div>
              <div><Label>Risposta</Label><Textarea rows={4} value={edit.answer} onChange={e => setEdit({...edit, answer: e.target.value})} /></div>
              <div><Label>Ordine</Label><Input type="number" value={edit.order} onChange={e => setEdit({...edit, order: parseInt(e.target.value) || 0})} /></div>
            </div>
            <DialogFooter><Button onClick={save} className="bg-[#2D6BFF] text-white">Salva</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
